import * as echarts from 'echarts';

document.querySelectorAll('[data-chart]').forEach(chartDiv => {

    if (chartDiv.dataset.chartInitialized) {
        return;
    }

    const chartInstance = echarts.init(chartDiv);

    const data = JSON.parse(chartDiv.dataset.chart);


    const option = {
        color: ['#9EA9B7', '#EFEFEF', '#3ED5DD', '#6D6F70', '#93FDAC'],

        tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%',
        },

        series: [
            {
                name: chartDiv.dataset.chartTitle,
                type: 'pie',

                radius: ['30%', '50%'],
                center: ['50%', '50%'],

                avoidLabelOverlap: true,

                itemStyle: {
                    borderRadius: 2,
                    borderColor: '#fbf9fa',
                    borderWidth: 4,
                },

                label: {
                    show: true,
                    position: 'outside',
                    width: 100,
                    overflow: 'break',

                    formatter: (p) => `{name|${p.name}}\n\n{percent|${p.percent}%}`,

                    rich: {
                        name: {
                            fontSize: 13,
                            fontWeight: 600,
                            color: '#333',
                            lineHeight: 22,
                        },
                        percent: {
                            fontSize: 13,
                            fontWeight: 400,
                            color: '#7a7a7a',
                            lineHeight: 18,
                        },
                    },
                },

                labelLine: {
                    show: true,
                    length: 18,
                    length2: 30,
                    minTurnAngle: 90,
                    smooth: false,
                    lineStyle: {
                        width: 1,
                    },
                },

                data,
            },
        ],
    };

    chartInstance.setOption(option);
    chartDiv.dataset.chartInitialized = true;

    const resizeObserver = new ResizeObserver(() => chartInstance.resize());
    resizeObserver.observe(chartDiv);
});
